export class PerformancePeerGroupFirmPreviewModel {
  firms: any[];
  totalCount: number;
  public constructor() {}
}
